import styled from 'styled-components'

export const Stamp = styled.div`
  background-image: url('/assets/img/blackfeirao/Card - 90x13.png');
  background-repeat: no-repeat;
  background-size: 100%;
  width: ${props => props.width};
  height: ${props => props.height};
`
